// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"24375e55","161":"ac1c713a","349":"0c375e6c","364":"007a50be","395":"3b1b5402","424":"3ff0b9e4","553":"f5587b8d","588":"b61ff741","658":"0810a119","835":"326246fa","847":"488f6604","897":"1a6dc4fe"}[chunkId] + ".chunk.js";
};